import * as React from 'react';
import { FullscreenCarousel, IMedia, TOnSlideChangeParams } from '@cian/frontend-fullscreen-carousel-component';
import { fullscreenMediaSettings, prepareSlides } from './utils';
import { IFullscreenSlide } from '../../types/gallery';
import { IMediaItem } from '../../types/newbuilding/constructionProgress';

export interface IFullscreenSliderGalleryProps {
  images: IMediaItem[];
  currentSlide: number;
  settings?: IMedia[];
  onClose(): void;
  onSlideChange(params: TOnSlideChangeParams): void;
}

export interface IFullscreenSliderGalleryState {
  slides: IFullscreenSlide[];
}

export class FullscreenSliderGallery extends React.PureComponent<
  IFullscreenSliderGalleryProps,
  IFullscreenSliderGalleryState
> {
  public state = {
    slides: prepareSlides(this.props.images),
  };

  public render() {
    const { onClose, onSlideChange, currentSlide, settings } = this.props;
    const { slides } = this.state;

    return (
      <FullscreenCarousel
        slides={slides}
        media={settings || fullscreenMediaSettings}
        onClose={onClose}
        defaultCurrentSlide={currentSlide}
        onSlideChange={onSlideChange}
      />
    );
  }
}
